// Material UI
import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  root: {
    alignItems: 'center',
    display: 'grid',
    gridAutoFlow: 'column',
    justifyContent: 'space-between',
    width: '100%',
  },
  detailHeaderIconRoot: {
    height: '1.125rem',
    width: '1.125rem',
  },
}));
